export const checkDept = (depts: String[]) => {
  if (depts && depts.length > 0) {
    const allSameDept = (depts: any[]) =>
      depts.every((val: any) => val === depts[0])
    return allSameDept(depts)
  }
}
